import { createFileRoute, Link } from '@tanstack/react-router'
import { Heading, Button, Flex, Text, Box } from '@radix-ui/themes'
import { LuClock, LuFilePlus2 } from 'react-icons/lu'
import { useQuery } from '@tanstack/react-query'
import { listScans } from './-service'
import NavigatableScanSummary from './-components/ScanListItem'

export const Route = createFileRoute('/plugins/eiffage-scans/')({
  component: RouteComponent
})

function RouteComponent() {
  const { org } = Route.useRouteContext()

  const options = {
    pageSize: 3
  }

  const { data } = useQuery({
    queryKey: ['scans', options],
    queryFn: async () => listScans(org.id, options)
  })

  return (
    <Flex direction="column" gap="6" p={'8'} width={'100%'} className="max-w-3xl mx-auto">
      <Heading size={'8'} align={'center'}>
        Carnets de suivi
      </Heading>
      <Flex direction="column" gap="3" className="mb-10">
        <Link to="/plugins/eiffage-scans/new" className="w-full">
          <Button size="4" className="w-full h-16" variant="solid">
            <LuFilePlus2 size={24} />
            <Text ml={'1'} size={'5'}>
              Nouveau Carnet
            </Text>
          </Button>
        </Link>
        {/* <Flex gap={'2'} justify={'center'} align="center" className="w-full visible sm:hidden">
          <Separator size="1" className="my-2" />
          <Text size="1" color="gray" align="center">
            ou
          </Text>
          <Separator size="1" className="my-2" />
        </Flex>
        <Link to="/eiffage/scans/history" className="w-full visible sm:hidden">
          <Button size="4" className="w-full" variant="outline">
            <LuClock size={20} />
            <Text ml={'1'} size={'3'}>
              Historique
            </Text>
          </Button>
        </Link> */}
        {data && data.length > 0 && (
          <Box my={'4'}>
            <Flex align="center" className="mb-3 w-full">
              <LuClock size={16} className="mr-2" />
              <Text size="3">Carnets de suivi récents</Text>
              {/* <LinkButton
                className="ml-auto invisible sm:visible"
                text={'Toutes les fiches'}
                trailingIcon={<ArrowRightIcon />}
              /> */}
            </Flex>
            <Flex direction={'column'} gap={'3'}>
              {data.map((scan) => (
                <NavigatableScanSummary key={scan.ID} scan={scan} className="w-full" />
              ))}
            </Flex>
          </Box>
        )}
      </Flex>
    </Flex>
  )
}
